import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminExportBuyerListMutation,
  AdminExportBuyerListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminExportBuyerListMutation = graphql(`
  mutation adminExportBuyerList($id: String!, $exportFormat: ExportFormatArgs!) {
    adminExportBuyerList(id: $id, ExportFormat: $exportFormat) {
      id
    }
  }
`);

/** Async export of a buyer list as admin (bypasses per-list RBAC). */
export function useAdminBuyerListExport(
  options?: UseMutationOptions<
    AdminExportBuyerListMutation,
    unknown,
    AdminExportBuyerListMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(adminExportBuyerListMutation, options);
  return { ...rest, data: data?.adminExportBuyerList };
}
